module.exports = __webpack_public_path__ + "static/media/avatar-light.1d2ad0aa.svg";